import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiErrorSanitizerInterceptor } from './core/interceptors/api-error-sanitizer.interceptor';
import { unauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';
import { RouteReuseStrategy } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { TranslateService } from '@ngx-translate/core';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { NotificationHostComponent } from './core/notifications';
import { ClientLayoutComponent } from './layout/client-layout/client-layout.component';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { I18nLocaleService, initClientI18n, provideClientI18n } from './core/i18n';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    NotificationHostComponent,
    ClientLayoutComponent,
    AdminLayoutComponent,
  ],
  providers: [
    provideHttpClient(withInterceptors([apiErrorSanitizerInterceptor, unauthorizedInterceptor])),
    ...provideClientI18n(),
    I18nLocaleService,
    provideAppInitializer(() => initClientI18n(inject(TranslateService), inject(I18nLocaleService))),
    providePrimeNG({
      theme: {
        preset: Aura, options: {
          darkModeSelector: false,
        },
      },
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
